import React, {useEffect, useState} from "react";
import './Categories.scss';
import { CategoryBox } from "../../components/CategoryBox/CategoryBox";
import CategoryService from "../../service/CategoryService";
import {useParams} from "react-router-dom";
import logo from "../../assets/rauchwolke1.png";
import Footer from "../../components/Footer/Footer";

export default function Categories(): JSX.Element {
    const { id } = useParams<{id: string}>();
    const [categories, setCategories] = useState([]);
    const [parentCategory, setParentCategory] = useState<{name: string, description: string, image: string}>();

    useEffect(() => {
        setCategories([]);
        setParentCategory(undefined);
        if (id) {
            CategoryService.getChildCategories(id)
                .then(result => {
                    if (result.error) {
                        return;
                    }
                    setCategories(result.data.categories);
                    setParentCategory(result.data.parent);
                });
        } else {
            CategoryService.getMainCategories()
                .then(result => {
                    if (result.error) {
                        return;
                    }
                    setCategories(result.data.categories);
                });
        }

    }, [id]);

    if (categories.length === 0) {
        return (
            <div>
                <h1>Loading...</h1>
                <Footer showBackButton={!!id} />
            </div>
        )
    }


    return (
        <div className={'categoriesPage'}>
            { parentCategory && id ?
                (
                    <>


                        <h1>{parentCategory.name}</h1>
                        {parentCategory.description && <div className={'description'}>{parentCategory.description}</div> }
                    </>
                ) : (<img className={"logo"} src={logo} alt="Rauchwolke Logo" />)
            }
            <div className={'categories'}>
                {categories.map(({name, id, image, hasChildren}, index) => (
                    <CategoryBox name={name} id={id} image={image} key={index} hasChildren={hasChildren}/>
                ))}
            </div>
            <Footer showBackButton={!!id} />
        </div>
    );
}
